/* Loads product recommendations with the Section Rendering API.
   "Complete your order": complementary products, then the category upsell collection (server rendered
   in a template), then related products. */
(function () {
  function load(el, url, selector, onEmpty) {
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector(selector);
        if (src && src.querySelector('.c-item')) {
          el.innerHTML = src.outerHTML;
          el.hidden = false;
        } else if (onEmpty) {
          onEmpty();
        }
      })
      .catch(function () { if (onEmpty) onEmpty(); });
  }

  document.querySelectorAll('[data-complementary]').forEach(function (el) {
    if (el.querySelector('[data-complementary-content]')) { el.hidden = false; return; }
    var tpl = el.querySelector('template[data-upsell-fallback]');
    var related = el.getAttribute('data-fallback-url');
    var selector = '[data-complementary] [data-complementary-content]';
    var next = function () {
      if (tpl && tpl.content && tpl.content.querySelector('.c-item')) {
        el.innerHTML = '';
        el.appendChild(tpl.content.cloneNode(true));
        el.hidden = false;
      } else if (related) {
        load(el, related, selector, null);
      }
    };
    load(el, el.getAttribute('data-url'), selector, next);
  });

  document.querySelectorAll('[data-related]').forEach(function (el) {
    if (el.querySelector('.p-card')) return;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-related]');
        if (src && src.querySelector('.p-card')) {
          el.innerHTML = src.innerHTML;
          el.closest('section, .related').hidden = false;
        }
      })
      .catch(function () {});
  });
})();
